import { makeStyles } from '@material-ui/core/styles';

/**
 * Shared styles for dialog components
 *
 * Provides consistent styling for close buttons and other dialog elements.
 * Used across all dialog component variants to maintain visual consistency.
 */
const useDialogStyles = makeStyles((theme) => ({
    closeButton: {
        float: 'right',
        marginTop: theme.spacing(-1),
        marginRight: theme.spacing(-1),
    },
}));

export default useDialogStyles;
